module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav'), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between align-start ",
    staticStyle: {
      "background": "#eef1fa",
      "padding": "30px 0",
      "min-height": "600px"
    }
  }, [(_vm.detail) ? _c('div', {
    staticClass: "marginauto animated fadeInUp",
    staticStyle: {
      "width": "1145px"
    }
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "width": "945px",
      "padding": "20px 100px 50px 100px",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "sd_title"
  }, [_c('p', {
    staticClass: "biaoti1"
  }, [_vm._v(_vm._s(_vm.detail.shop_name))]), _vm._v(" "), _c('p', {
    staticClass: "bt_mes"
  }, [_vm._v("\n                        主营业务：" + _vm._s(_vm.detail.cat_name) + "\n                    ")])]), _vm._v(" "), (_vm.detail.content) ? _c('div', {
    staticClass: "sd_content padding-top "
  }, [_c('div', {
    staticClass: "meeting-detail-intro",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  })]) : _c('div', [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "咨询",
      "visible": _vm.addcompany
    },
    on: {
      "update:visible": function($event) {
        _vm.addcompany = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "60%",
      "margin": "0 auto"
    }
  }, [_c('el-form', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "model": _vm.cominfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "name", $$v)
      },
      expression: "cominfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.phone),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "phone", $$v)
      },
      expression: "cominfo.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "咨询内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入咨询内容",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.content),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "content", $$v)
      },
      expression: "cominfo.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center align-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.nowdisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.tosub
    }
  }, [_vm._v("提 交")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a83d8118"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/comdetail.vue
// module id = 418
// module chunks = 1